// Centralized authentication utilities
// Handles token expiration and logout functionality

import { STORAGE_KEYS } from "./constants";

/**
 * Handles token expiration by clearing local storage and redirecting to login
 * This function can be called from anywhere (React components, API services, etc.)
 * 
 * @param reason - Optional reason for logout (e.g., 'Token expired', 'User logged out')
 */
export async function handleTokenExpiration(reason: string = 'Session expired'): Promise<void> {
  try {
    console.log(`🔒 Handling token expiration: ${reason}`);
    
    // Remove token from storage
    await OfficeRuntime.storage.removeItem(STORAGE_KEYS.TOKEN);
    console.log('✅ Token removed from storage');
    
    // Redirect to login page
    if (typeof window !== 'undefined') {
      const currentPath = window.location.hash;
      // Only redirect if not already on login page
      if (!currentPath.includes('/login')) {
        window.location.hash = '/login';
        console.log('✅ Redirected to login page');
      }
    }
  } catch (error) {
    console.error('❌ Error handling token expiration:', error);
    // Even if there's an error, try to redirect
    if (typeof window !== 'undefined' && !window.location.hash.includes('/login')) {
      window.location.hash = '/login';
    }
  }
}

/**
 * Checks if user is currently authenticated
 * @returns Promise<boolean> - true if token exists, false otherwise
 */
export async function isAuthenticated(): Promise<boolean> {
  try {
    const token = await OfficeRuntime.storage.getItem(STORAGE_KEYS.TOKEN);
    return !!token;
  } catch (error) {
    console.error('Error checking authentication:', error);
    return false;
  }
}

